import type { Booking, BookingsOverviewState } from '@/scopes/account/bookings-overview/domain/types'

export function isCancelledTabActive(state: BookingsOverviewState) {
  return state.bookingHistoryActiveTab === 'cancelled'
}

export function isPastTabActive(state: BookingsOverviewState) {
  return state.bookingHistoryActiveTab === 'past'
}

export function isPageLoading(state: BookingsOverviewState) {
  return state.bookingOverviewPageLoadStatus === 'loading'
}

export function isPageError(state: BookingsOverviewState) {
  return state.bookingOverviewPageLoadStatus === 'error'
}

export function isPageSuccess(state: BookingsOverviewState) {
  return state.bookingOverviewPageLoadStatus === 'success'
}

function sortBookingsByDateDesc(bookings: Record<string, Booking>): Booking[] {
  return Object.values(bookings).sort((a, b) => {
    const dateA = new Date(a.rawDepartureDate)
    const dateB = new Date(b.rawDepartureDate)

    const timeA = dateA.getTime()
    const timeB = dateB.getTime()

    if (Number.isNaN(timeA) && Number.isNaN(timeB))
      return 0

    if (Number.isNaN(timeA))
      return 1
    if (Number.isNaN(timeB))
      return -1

    return timeB - timeA
  })
}

export function getSortedPastBookings(state: BookingsOverviewState): Booking[] {
  return sortBookingsByDateDesc(state.pastBookings)
}

export function getSortedCancelledBookings(state: BookingsOverviewState): Booking[] {
  return sortBookingsByDateDesc(state.cancelledBookings)
}
